<template>
  <el-dialog
    class="default-model"
    title="选择数据范围"
    :visible.sync="dialogVisible"
    width="650px"
    @close="onClose"
    append-to-body
    :close-on-click-modal="false"
  >
    <div>
      <el-form ref="searchForm" :model="searchForm" :rules="rules" label-position="top">
        <el-form-item label="选择任务" prop="roundIds">
          <!-- <el-select class="w100" v-model="searchForm.roundIds" filterable clearable multiple placeholder="请选择任务">
            <el-option :label="item.name" v-for="item in roundList" :key="item.roundId" :value="item.roundId"></el-option>
          </el-select> -->
          <el-cascader class="w100" v-model="searchForm.roundIds" :options="roundList" :props="props" clearable filterable></el-cascader>
        </el-form-item>
        <div class="foot">
          <el-button @click="onClose" class="mr-10">取消</el-button>
          <el-button @click="onSearch" class="mr-10" type="primary">确认</el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
import ApiDataView from '@/apis/api-data-view.js';
import * as _storage from '@/utils/storage.js';
export default {
  name: 'select-data',
  props: ['visible'],
  data() {
    return {
      props: {
        multiple: true,
        children: 'rangeBookTimes'
      },
      searchForm: {
        roundIds: []
      },
      rules: {
        roundIds: [
          { type: 'array', required: true, message: '请至少选择一个任务', trigger: 'change' }
        ],
      },
      roundList: []
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.getRoundList()
  },
  methods: {
    async getRoundList() {
      const res = await ApiDataView.GETmonitorRound()
      if (res) {
        this.roundList = res.map(v => {
          v.value = v.roundId
          v.label = v.roundName
          if (v.rangeBookTimes) {
            v.rangeBookTimes.forEach(k => {
              k.value = k.bookTimeId
              k.label = k.BookTimeRange
            })
          }
          return {...v}
        })
      } else {
        this.roundList = []
      }
    },
    onSearch() {
      this.$refs['searchForm'].validate(async (valid) => {
        if (valid) {
          const {result, resultMap, title} = this.formatParam(this.searchForm.roundIds)
          console.log(result, 'param')
          const res = await ApiDataView.POSTstatistic({roundBookTimes: result})
          if (res.statisticId) {
            const dataRange = {
              result,
              resultMap,
              title
            }
            _storage.setStorageSync('dataRange', dataRange)
            _storage.setStorageSync('statisticId', res.statisticId)
            this.$emit('getStatisticId', res.statisticId)
            this.$emit('getDataRange', dataRange)
            this.onClose()
          } else {
            this.$message.error('暂无数据，请重试！')
          }
        } else {
          return false;
        }
      });
    },
    formatParam(param) {
      const result = []
      const resultMap = {}
      const title = []
      if (param && param.length) {
        param.forEach(v => {
          const key = v[0]
          const value = v.length > 1 ? v.slice(1) : []
          if (Reflect.has(resultMap, v[0])) {
            resultMap[key] = [...resultMap[key], ...value]
          } else {
            resultMap[key] = value
          }
        })
      }
      for (const [k, v] of Object.entries(resultMap)) {
        const currentRound = this.roundList.filter(r => r.roundId === k)[0]
        let str = currentRound.roundName
        if (v && v.length) {
          const books = currentRound.rangeBookTimes.filter(c => v.includes(c.bookTimeId)).map(f => f.BookTimeRange)
          str = `${str}(${books.join('，')})`
        }
        const item = {roundId: k, bookTimeIds: v}
        result.push(item)
        title.push(str)
      }
      return {result, resultMap, title}
    },
    onClose() {
      this.$emit('update:visible', false)
    }
  }
};
</script>
<style scoped>
.default-model >>> .el-dialog {
  border-radius: 6px;
}
.default-model >>> .el-dialog__body {
  padding: 0 20px 10px;
}
.line {
  display: flex;
  justify-content: center;
  align-items: center;
}
.foot {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 20px;
}
/* 时分秒选择器，隐藏秒 */
.default-model >>> .el-time-spinner__wrapper {
  width: 50%;
}
</style>
